// Barra de pestañas inferior — vía de escape siempre visible (mobile-first).
// Back = navegar dentro de una sección; estas pestañas = saltar entre secciones
// sin encadenar "atrás". Se oculta en flujos a pantalla completa (wizards).
export default function BottomTabBar({ items, className = "" }) {
  return (
    <nav
      className={`no-print fixed bottom-0 inset-x-0 z-30 bg-paper/95 backdrop-blur-md border-t border-edge${className ? ` ${className}` : ""}`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Navegación principal"
    >
      <div className="max-w-[820px] mx-auto px-1 h-14 flex items-stretch">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <button
              key={it.key}
              type="button"
              onClick={it.onClick}
              aria-label={it.badge ? `${it.label} (tiene algo para ti)` : it.label}
              aria-current={it.active ? 'page' : undefined}
              className={`relative flex-1 flex flex-col items-center justify-center gap-0.5 rounded-tk-md transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 ${
                it.active ? 'text-accent' : 'text-ink-muted hover:text-ink'
              }`}
            >
              {/* Punto de novedad: Benito terminó una respuesta con el panel
                  cerrado. Nunca se combina con `active` (App apaga la novedad
                  al abrir el panel), pero relative en el botón lo sostiene igual. */}
              {it.badge && (
                <span className="absolute top-1.5 right-[calc(50%-16px)] w-2 h-2 rounded-full bg-clinical-stable ring-2 ring-paper" aria-hidden="true" />
              )}
              <Icon size={21} strokeWidth={it.active ? 2 : 1.7} />
              {/* labelCorto: nombre abreviado para la barra del teléfono cuando el
                  completo no cabe en 10 px ("MiPAE en turno" → "En turno"). El
                  aria-label conserva el nombre completo, que contiene al corto. */}
              <span className="text-10px font-sans font-medium leading-none">{it.labelCorto || it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
